import { createApp } from "vue";

import AccordionSearch from "./AccordionSearch.vue";

const handle = "almero-vue-accordion-search";
const mountEls = document.querySelectorAll(`.${handle}`);

mountEls?.forEach((mountEl) => {
    const app = createApp(
        AccordionSearch
    );
    
    app.component("AccordionSearch", AccordionSearch);
    app.mount(mountEl);
});